import React, { type RefObject, type ReactNode, useEffect } from 'react';
import { useAnalyticsEvents } from '@atlaskit/analytics-next/useAnalyticsEvents';
import { ModalTrigger } from '@atlassian/entry-points/modal-trigger';
import { fireUIAnalytics } from '@atlassian/jira-product-analytics-bridge';
import { viewBlueprintsEntrypoint } from './viewBlueprintsEntrypoint.entrypoint.tsx';
import { modalProps } from './ui/modal/constants.tsx';

type ViewBlueprintsModalTriggerProps = {
	children: ({ ref }: { ref: RefObject<HTMLElement> }) => ReactNode;
	showSettingsLink?: boolean;
};

export const ViewBlueprintsModalTrigger = ({
	children,
	showSettingsLink = true,
}: ViewBlueprintsModalTriggerProps): React.JSX.Element => {
	const { createAnalyticsEvent } = useAnalyticsEvents();
	useEffect(() => {
		fireUIAnalytics(createAnalyticsEvent({}), 'button rendered', 'viewBlueprintsTrigger');
	}, [createAnalyticsEvent]);
	const fireButtonClickedEvent = () => {
		fireUIAnalytics(createAnalyticsEvent({}), 'button clicked', 'viewBlueprintsTrigger');
	};

	return (
		<ModalTrigger
			entryPoint={viewBlueprintsEntrypoint}
			entryPointProps={{ showSettingsLink }}
			modalProps={{
				...modalProps,
				onOpenComplete: fireButtonClickedEvent,
			}}
		>
			{children}
		</ModalTrigger>
	);
};
